<template>
  <div class="refund-main">
    <div v-if="isLoading">
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 0"
        height="141px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="240px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="220px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="160px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="240px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="175px"
        style="margintop: 5px"
        height="43px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="110px"
        style="margintop: 25px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 10px"
        height="15px"
      />
    </div>
    <div v-else>
      <div
        v-if="
          this.order == null ||
          (!this.order.offerId && this.order.customers.length == 0)
        "
        class="refund-error"
      >
        <p>
          <b>{{ "Заказ с номером (PNR) " + this.pnr + " не найден." }}</b>
        </p>
        <p class="refund-error__firsttext">
          Распечатайте
          <a
            href="https://www.biletdv.ru/customer/download/RefundOrder.doc"
            class="refund-error__doc-link"
            >бланк заявления</a
          >
          на возврат, заполните его и отправьте на адрес
          <a href="mailto:orders@biletdv.ru" class="refund-error__mail"
            >orders@biletdv.ru</a
          >.
        </p>
        <p class="refund-error__secondtext">
          Если вам нужна консультация - задайте вопрос в онлайн чате или по
          телефону <a href="tel:+74956655313">+7 (495) 665-53-13</a>.
        </p>
      </div>
      <div v-else>
        <Dialog
          v-model:visible="display"
          v-if="this.order.customers.length > 0"
        >
          <template #header>
            <h3>Выберите билеты для возврата</h3>
          </template>
          <div
            v-for="(ticket, index) in this.order.customers"
            :key="index"
            class="support-request__changetickets-choose__form"
          >
            <Checkbox
              class="support-request__changetickets-choose__form-checkbox"
              :id="'ticket' + index"
              name="tickets"
              :value="ticket.customer.TicketNumber"
              v-model="checkedTickets"
            />
            <label
              class="support-request__changetickets-choose__form-label"
              :for="'ticket' + index"
              >{{
                ticket.customer.TicketNumber +
                " " +
                nameChangerForDialog(ticket.customer.LastName)
              }}</label
            >
          </div>

          <p
            class="support-request__changetickets-choose__form-error"
            v-show="this.checkTicketsError"
          >
            Необходимо выбрать хотя бы один билет
          </p>

          <template #footer>
            <Button
              label="Оформить возврат"
              autofocus
              @click="tikectsForRefund"
            />
          </template>
        </Dialog>
        <div v-if="loadingWhileDialog">
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 0"
            height="141px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="240px"
            style="margintop: 15px"
            height="20px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 3px"
            height="40px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="220px"
            style="margintop: 15px"
            height="20px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 3px"
            height="40px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="160px"
            style="margintop: 15px"
            height="20px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 3px"
            height="40px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="240px"
            style="margintop: 15px"
            height="20px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="175px"
            style="margintop: 5px"
            height="43px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="110px"
            style="margintop: 25px"
            height="40px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 10px"
            height="15px"
          />
        </div>
        <div v-else>
          <div
            v-for="(customer, index) in this.choosedTickets"
            :key="index"
            class="refund-main__segments"
          >
            <div class="refund-main__segment-card">
              <div>
                <div class="refund-main__segment-card__passenger">
                  <div class="refund-main__segment-card__passenger-name">
                    <img
                      :src="require(`../assets/images/person.svg`)"
                      alt=""
                      class="refund-main__segment-card__passenger-name__icon"
                    />
                    <p class="refund-main__segment-card__passenger-name__text">
                      {{ nameCaseChanger(customer.customer.LastName) }}
                    </p>
                  </div>
                  <div class="refund-main__segment-card__passenger-ticket">
                    <img
                      :src="require(`../assets/images/boarding-pass.svg`)"
                      alt=""
                      class="refund-main__segment-card__passenger-ticket__icon"
                    />
                    <p
                      class="refund-main__segment-card__passenger-ticket__text"
                    >
                      {{ customer.customer.TicketNumber }}
                    </p>
                  </div>
                </div>
                <div
                  v-for="seg in customer.customer.Segments"
                  :key="seg.Id"
                  class="refund-main__segment-card__segment"
                >
                  <Accordion>
                    <AccordionTab>
                      <template
                        #header
                        class="refund-main__segment-card__accordion-header"
                      >
                        <span>{{
                          "Рейс " +
                          seg.CarrCode.replace(/ /g, "") +
                          "-" +
                          seg.FlNumber.replace(/ /g, "")
                        }}</span>
                        <input
                          type="checkbox"
                          @click="
                            changeCheck(seg, customer.customer.Id, seg.SegNumber, this.order)
                          "
                          :checked="
                            this.order.customers.find(x => x.customer.Id === customer.customer.Id).customer.Segments[
                              seg.SegNumber - 1
                            ].IsNeeded
                          "
                          name=""
                          id=""
                          class="
                            refund-main__segment-card__accordion-header__check
                          "
                        />
                      </template>
                      <div class="refund-main__segment-card__segment-date">
                        <p
                          class="
                            refund-main__segment-card__segment-date__header
                          "
                        >
                          Дата перелёта
                        </p>
                        <p
                          class="refund-main__segment-card__segment-date__text"
                        >
                          {{
                            getDate(seg.DptDt) + ", " + getWeekDay(seg.DptDt)
                          }}
                        </p>
                      </div>
                      <div class="refund-main__segment-card__segment-airline">
                        <p
                          class="
                            refund-main__segment-card__segment-airline__header
                          "
                        >
                          Номер рейса
                        </p>
                        <div
                          class="
                            refund-main__segment-card__segment-airline__wrapper
                          "
                        >
                          <img
                            class="
                              refund-main__segment-card__segment-airline__icon
                            "
                            :src="`https://www.biletdv.ru/Content/images/companies/${info.CarrCode.replace(
                              / /g,
                              ''
                            )}.svg`"
                            alt="company logo"
                          />
                          <p
                            class="
                              refund-main__segment-card__segment-airline__text
                            "
                          >
                            {{
                              seg.CarrCode.replace(/ /g, "") +
                              "-" +
                              seg.FlNumber.replace(/ /g, "")
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="refund-main__segment-card__segment-route">
                        <p
                          class="
                            refund-main__segment-card__segment-route__header
                          "
                        >
                          Маршрут
                        </p>
                        <div
                          class="
                            refund-main__segment-card__segment-route__wrapper
                          "
                        >
                          <p
                            class="
                              refund-main__segment-card__segment-route__text
                            "
                          >
                            {{ seg.DAport }}
                          </p>
                          <div
                            class="
                              refund-main__segment-card__segment-route__icon
                            "
                          >
                            <svg
                              width="15"
                              height="11"
                              viewBox="0 0 15 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.535 4.73432L9.8475 1.63988C9.27 1.25901 8.38031 1.29201 7.86094 1.71688C7.34156 2.13969 7.38844 2.79213 7.96594 3.173L9.92813 4.46894H1.40625C0.629063 4.46894 0 4.93025 0 5.50019C0 6.07013 0.629063 6.53144 1.40625 6.53144H9.93L7.965 7.82738C7.3875 8.20894 7.34062 8.86069 7.86 9.2835C8.13844 9.50969 8.52188 9.62519 8.90625 9.62519C9.24188 9.62519 9.57844 9.53788 9.84656 9.3605L14.5341 6.26744C14.8303 6.07219 15 5.79307 15 5.50088C15 5.20869 14.8303 4.92957 14.535 4.73432Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <p
                            class="
                              refund-main__segment-card__segment-route__text
                            "
                          >
                            {{ seg.AAport }}
                          </p>
                        </div>
                      </div>
                      <div class="refund-main__segment-card__segment-state">
                        <p
                          class="
                            refund-main__segment-card__segment-state__header
                          "
                        >
                          Статус возврата
                        </p>
                        <p
                          class="refund-main__segment-card__segment-state__text"
                        >
                          {{ seg.IsReturned ? "Возвращён" : "Не возвращён" }}
                        </p>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
          <p v-show="this.allUnchecked" class="refund-main__unchecked">
            Необходимо выбрать хотя бы один сегмент
          </p>

          <p class="refund-main__mail">Адрес электронной почты (E-mail)</p>
          <InputText type="text" v-model="passMail" />
          <p
            class="refund-main__mail-valid"
            :class="{ isinvalid: isMailInvalid }"
          >
            Это поле обязательно для заполнения
          </p>
          <p class="refund-main__phone">Контактный номер телефона</p>
          <InputText type="text" v-model="passPhone" />
          <p
            class="refund-main__phone-valid"
            :class="{ isinvalid: isPhoneInvalid }"
          >
            Это поле обязательно для заполнения
          </p>
          <p class="refund-main__reason">Причина возврата:</p>
          <Dropdown
            class="refund-main__reason-dropdown"
            v-model="selectedReason"
            :options="reasons"
            optionLabel="name"
            placeholder="Выберите причину"
          />
          <p
            class="refund-main__reason-valid"
            :class="{ isinvalid: isReasonInvalid }"
          >
            Это поле обязательно для заполнения
          </p>
          <div
            v-if="
              this.selectedReason.name ==
              'Болезнь пассажира или члена его семьи'
            "
            class="refund-main__reason-description__item"
          >
            <p class="refund-main__reason-description__item-text">
              Болезнь пассажира или члена его семьи либо близкого родственника,
              совместно следующего с ним на воздушном судне, является основанием
              для вынужденного отказа пассажира от перевозки при наличии
              подтверждаемых медицинскими документами противопоказаний к полету
              на дату отправления воздушного судна, указанную в билете.
            </p>
          </div>
          <div
            v-else-if="this.selectedReason.name == 'Иное'"
            class="refund-main__reason-description__item"
          >
            <p class="refund-main__reason-description__item-text">
              Требуется подробно описать причину и приложить подтверждающие
              документы.
            </p>
          </div>
          <div v-if="this.selectedReason.name == 'Иное'">
            <Editor
              class="support-request__form-description__textarea"
              v-model="description"
              editorStyle="height: 160px"
            >
              <template #toolbar>
                <span class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                  <button class="ql-underline"></button>
                  <button class="ql-list" value="ordered"></button>
                </span>
              </template>
            </Editor>
          </div>
          <div
            v-if="this.selectedReason.name !== 'Добровольный возврат'"
            class="support-request__form-upload"
          >
            <p class="support-request__form-upload__title">
              Прикреплённые файлы
              <span class="request__optional">(необязательно)</span>
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.fileSizeEx"
            >
              Размер файлов не должен привышать 20Мб, размер одного файла - не
              более 10Мб.
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.maxFileCount"
            >
              Количество файлов - не более 10ти.
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.wrongFileFormat"
            >
              Допустимые форматы файлов: .png, .jpg, .jpeg, .pdf, .tif, .tiff,
              .pjpeg, .pjp
            </p>
            <input
              type="file"
              id="files"
              ref="files"
              multiple
              accept=".png, .jpg, .jpeg, .pdf, .tiff, .pjpeg, .pjp"
              @change="handleFileUpload()"
              class="support-request__form-upload__mob-input"
            />
            <label for="files" class="support-request__form-upload__mob"
              >Выбрать файлы</label
            >
            <div v-if="this.showAttachedFiles">
              <div
                v-for="(file, index) in this.files.files"
                :key="index"
                class="support-request__form-upload__show"
              >
                <p class="support-request__form-upload__show-item">
                  {{ file.name }}
                </p>
              </div>
            </div>
          </div>
          <Button
            type="button"
            label="Оформить"
            :loading="loading"
            class="refund-main__submitbtn"
            @click="submitCheck"
          />
          <p class="refund-main__rules">
            Нажимая «Оформить» я подтверждаю , что ознакомился с
            <router-link
              :to="{
                name: 'RefundRules',
              }"
              ><p class="refund-main__rules-link">
                правилами возврата
              </p></router-link
            >
            и принимаю их.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, watch } from "vue";
import InputText from "primevue/inputtext";
import axios from "axios";
import Ripple from "primevue/ripple";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { useRouter, useRoute } from "vue-router";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import Editor from "primevue/editor";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RefundMain",
  components: {
    InputText,
    Button,
    Skeleton,
    Accordion,
    AccordionTab,
    Dropdown,
    Editor,
    Dialog,
    Checkbox,
  },
  props: ["pnr", "guid", "ticketNumber"],
  setup(props) {
    const isLoading = ref(false);
    const loadingWhileDialog = ref(false);
    const checkedTickets = ref<any>([]);
    const checkTicketsError = ref(false);
    const display = ref(false);
    const choosedTickets = ref<any>([]);
    const selectedReason = ref({ name: "" });
    const description = ref("");
    const subIndex = ref([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]);
    const reasons = ref([
      { name: "Добровольный возврат" },
      { name: "Отмена или задержка рейса" },
      { name: "Болезнь пассажира или члена его семьи" },
      { name: "Иное" },
    ]);
    const isMailInvalid = ref(false);
    const isPhoneInvalid = ref(false);
    const isReasonInvalid = ref(false);
    const router = useRouter();
    const route = useRoute();
    const passMail = ref("");
    const passPhone = ref("");
    const reason = ref("");
    const loading = ref(false);
    const order = ref<any | null>(null);
    const checkedOrder = ref(null);
    const error = ref(null);
    const files = ref<any | null>(null);
    const wrongFileFormat = ref(false);
    const maxFileCount = ref(false);
    const fileSizeEx = ref(false);
    const checkBeforeSumbit = ref(true);
    const showAttachedFiles = ref(false);
    const adjError = ref(false);
    const allUnchecked = ref(false);
    const getOrderForRefund = async () => {
      isLoading.value = true;
      loadingWhileDialog.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderForRefund?guid=${props.guid}&ticketNumber=${props.ticketNumber}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;
          console.log(fetchedOrders);
          if (fetchedOrders.offerId) {
            router.replace({
              name: "Offer",
              params: { offerId: fetchedOrders.offerId[0] },
            });
          } else {
            order.value = fetchedOrders;
            console.log(order.value);

            checkedOrder.value = fetchedOrders;

            passPhone.value = fetchedOrders.info.Phone.Number;
            passMail.value = fetchedOrders.info.EMail;
            if (order.value.customers.length > 0) {
              checkedTickets.value.push(props.ticketNumber);
              display.value = true;
            } else {
              loadingWhileDialog.value = false;
              isLoading.value = false;
            }
          }
        } else {
          console.log("error!");
          isLoading.value = false;
        }

        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const rerouteToSuccess = function (id: number) {
      router.replace({
        name: "Success",
        params: { requestNumber: id },
      });
    };
    watch([passMail, passPhone, selectedReason], (newValue, oldValue) => {
      if (isMailInvalid.value == true && passMail.value) {
        isMailInvalid.value = false;
      }
      if (isPhoneInvalid.value == true && passPhone.value) {
        isPhoneInvalid.value = false;
      }
      if (isReasonInvalid.value == true && selectedReason.value.name) {
        isReasonInvalid.value = false;
      }
    });
    const submitRefund = async (
      order: any,
      mail: string,
      phone: string,
      reason: string,
      pnr: string,
      description: string
    ) => {
      let checked = "";

      for (let i = 0; i < order.customers.length; i++) {
        for (let j = 0; j < order.customers[i].customer.Segments.length; j++) {
          if (order.customers[i].customer.Segments[j].IsNeeded == true) {
            if (checked.length > 0) {
              checked += ",";
            }
            checked += order.customers[i].customer.Segments[j].Id.toString();
          }
        }
      }

      let reqParams = {
        segmentIds: checked,
        email: mail,
        phone: phone,
        reason: reason,
        pnr: pnr,
        description: description,
      };
      let bodyFormData = new FormData();
      let finalParams = JSON.stringify(reqParams);
      const blob = new Blob([finalParams], { type: "application/json" });
      bodyFormData.append("Details", blob);
      if (files.value) {
        files.value.files.forEach((el: any) => {
          bodyFormData.append(el.name, el, el.name);
        });
      }
      if (!checked) {
        allUnchecked.value = true;
      } else {
        allUnchecked.value = false;
      }
      if (
        maxFileCount.value ||
        fileSizeEx.value ||
        wrongFileFormat.value ||
        !checked
      ) {
        return;
      } else {
        loading.value = true;
        try {
          axios({
            method: "POST",
            url: `https://www.biletdv.ru/customer/IBEServices/SaveOffer`,
            data: bodyFormData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }).then((res) => {
            if (res.status == 200) {
              loading.value = false;
              rerouteToSuccess(res.data.id);
            }
          });
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      }
    };
    return {
      passMail,
      passPhone,
      reason,
      isLoading,
      loading,
      order,
      error,
      getOrderForRefund,
      checkedOrder,
      submitRefund,
      router,
      route,
      rerouteToSuccess,
      isMailInvalid,
      isPhoneInvalid,
      isReasonInvalid,
      reasons,
      selectedReason,
      description,
      subIndex,
      files,
      wrongFileFormat,
      maxFileCount,
      fileSizeEx,
      checkBeforeSumbit,
      showAttachedFiles,
      adjError,
      allUnchecked,
      checkTicketsError,
      checkedTickets,
      display,
      loadingWhileDialog,
      choosedTickets,
    };
  },
  created() {
    this.getOrderForRefund();
  },
  methods: {
    tikectsForRefund() {
      if (this.checkedTickets.length == 0) {
        this.checkTicketsError = true;
      } else {
        for (let i = 0; i < this.checkedTickets.length; i++) {
          for (let j = 0; j < this.order.customers.length; j++) {
            if (
              this.checkedTickets[i] ==
              this.order.customers[j].customer.TicketNumber
            ) {
              this.choosedTickets.push(this.order.customers[j]);
            }
          }
        }
        this.isLoading = false;
        this.loadingWhileDialog = false;
        this.display = false;
        console.log(this.checkedTickets);
        console.log(this.choosedTickets);
      }
    },
    handleFileUpload() {
      if (this.files !== null) {
        let filesSize = 0;
        if (this.files.files.length > 0) {
          this.showAttachedFiles = true;
        } else {
          this.showAttachedFiles = false;
        }
        for (let i = 0; i < this.files.length; i++) {
          if (this.files.files[i].size > 10485760) {
            this.fileSizeEx = true;
          } else {
            this.fileSizeEx = false;
          }
          if (
            this.files.files[i].type !== "image/png" &&
            this.files.files[i].type !== "image/jpg" &&
            this.files.files[i].type !== "image/jpeg" &&
            this.files.files[i].type !== "image/pjp" &&
            this.files.files[i].type !== "image/pjpeg" &&
            this.files.files[i].type != "application/pdf" &&
            this.files.files[i].type !== "image/tiff"
          ) {
            console.log("must be true" + this.files.files[i].type);
            this.wrongFileFormat = true;
          } else {
            console.log("must be false" + this.files.files[i].type);
            this.wrongFileFormat = false;
          }

          filesSize += this.files.files[i].size;
        }
        if (filesSize > 22020096) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (this.files.files.length > 10) {
          this.maxFileCount = true;
        } else {
          this.maxFileCount = false;
        }
        if (this.files.files.length == 0) {
          this.wrongFileFormat = false;
        }
        if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
          this.checkBeforeSumbit = false;
        } else {
          this.checkBeforeSumbit = true;
        }
        console.log(this.files.files[0]);
        console.log(this.wrongFileFormat);
      }
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    nameCaseChanger(name: string): string {
      let splitedName = name.split(" ");
      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        normalName += firstLetterUpperCase + " ";
      }
      return normalName;
    },
    nameChangerForDialog(name: string): string {
      let splitedName = name.split(" ");

      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        if (i + 1 == splitedName.length) {
          normalName += firstLetterUpperCase;
        } else {
          normalName += firstLetterUpperCase + " ";
        }
      }
      let splitedNormalName = normalName.split(" ");
      console.log(splitedNormalName);
      let nameForDialog = "";
      if (splitedNormalName.length == 3) {
        nameForDialog =
          splitedNormalName[0] +
          " " +
          splitedNormalName[1][0] +
          "." +
          splitedNormalName[2][0] +
          ".";
      } else {
        nameForDialog =
          splitedNormalName[0] + " " + splitedNormalName[1][0] + ".";
      }

      return nameForDialog;
    },
    changeCheck(seg: any, customerId: any, subIndex: any, order: any) {
      // seg.IsNeeded = !seg.IsNeeded;
      console.log("order.customers:",order.customers);
      var cust = order.customers.find((x: { customer: { Id: any; }; }) => x.customer.Id === customerId);
      if (seg.IsNeeded == false) 
      {
        for (let i = subIndex - 1; i < cust.customer.Segments.length; i++) 
        {
          cust.customer.Segments[i].IsNeeded = true;
          console.log("s1:",cust.customer.Segments[i]);
        }
      } 
      else if (seg.IsNeeded == true) 
      {
        for (let i = subIndex - 1; i >= 0; i--) {
          cust.customer.Segments[i].IsNeeded = false;
          console.log("s2:",cust.customer.Segments[i]);
        }
      }
      console.log("s3:",seg);
      console.log("choosedTickets:", this.choosedTickets);
      this.allUnchecked = false;
    },
    
    submitCheck() {
      if (
        this.passMail == "" &&
        this.passPhone == "" &&
        this.selectedReason.name == ""
      ) {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.passPhone == "") {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
      } else if (this.passPhone == "" && this.selectedReason.name == "") {
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.selectedReason.name == "") {
        this.isMailInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "") {
        this.isMailInvalid = true;
      } else if (this.passPhone == "") {
        this.isPhoneInvalid = true;
      } else if (this.selectedReason.name == "") {
        console.log(this.selectedReason);
        this.isReasonInvalid = true;
      } else {
        this.isMailInvalid = false;
        this.isPhoneInvalid = false;
        this.isReasonInvalid = false;
        this.submitRefund(
          this.order,
          this.passMail,
          this.passPhone,
          this.selectedReason.name,
          this.pnr,
          this.description
        );
      }
    },
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style>
.refund-main__segments {
  margin-bottom: 15px;
}
.refund-main__segment-card {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 5px;
}

.refund-main__segment-card__passenger-name {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.refund-main__segment-card__passenger-name__icon {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.refund-main__segment-card__passenger-name__text {
  font-size: 1rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.refund-main__segment-card__passenger-ticket {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}

.refund-main__segment-card__passenger-ticket__icon {
  width: 23px;
  height: 25px;
  margin-right: 15px;
}

.refund-main__segment-card__passenger-ticket__text {
  font-size: 1rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.p-accordion-header-link {
  justify-content: space-between !important;
}

.refund-main__segment-card__accordion-header__check {
  width: 20px;
  height: 20px;
  border-radius: 5px;
}

.refund-main__segment-card__segment-date__header {
  font-weight: 600;
  color: #939090;
}

.refund-main__segment-card__segment-date__text {
  font-weight: 600;
  color: #000;
}

.refund-main__segment-card__segment-airline {
  margin-top: 10px;
}

.refund-main__segment-card__segment-airline__wrapper {
  display: flex;
  align-items: center;
}

.refund-main__segment-card__segment-airline__header {
  color: #939090;
  font-weight: 600;
}

.refund-main__segment-card__segment-airline__icon {
  max-height: 30px;
  max-width: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.refund-main__segment-card__segment-airline__text {
  font-weight: 600;
  color: #000;
}

.refund-main__segment-card__segment-route {
  margin-top: 10px;
}

.refund-main__segment-card__segment-route__header {
  font-weight: 600;
  color: #939090;
}

.refund-main__segment-card__segment-route__wrapper {
  display: flex;
  margin-top: 3px;
}

.refund-main__segment-card__segment-route__text {
  font-weight: 600;
  color: #000;
}

.refund-main__segment-card__segment-route__icon {
  margin-right: 5px;
  margin-left: 5px;
}

.refund-main__segment-card__segment-state {
  margin-top: 10px;
}

.refund-main__segment-card__segment-state__header {
  font-weight: 600;
  color: #939090;
}

.refund-main__segment-card__segment-state__text {
  font-weight: 600;
  margin-top: 3px;
  color: #000;
}

.refund-main__unchecked {
  color: red;
  font-size: 12px;
  margin-top: 15px;
  margin-bottom: 10px;
}

.refund-main__submitbtn {
  margin-top: 25px !important;
}

.refund-main__mail {
  margin-bottom: 3px;
}

.refund-main__phone {
  margin-top: 15px;
  margin-bottom: 3px;
}

.refund-main__reason {
  margin-top: 15px;
  margin-bottom: 3px;
}

.refund-main__reason-description__item {
  margin-top: 10px;
  font-size: 14px;
  line-height: 150%;
}

.refund-main__mail-valid {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  display: none;
}

.refund-main__phone-valid {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  display: none;
}

.refund-main__reason-valid {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  display: none;
}

.isinvalid {
  display: block;
}

.refund-main__reason-dropdown {
  width: 100%;
}

.refund-error {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 15px;
}

.refund-error__firsttext {
  margin-top: 15px;
}

.refund-error__secondtext {
  margin-top: 15px;
}

.refund-main__rules {
  margin-top: 10px;
  font-size: 12px;
}

.refund-main__rules-link {
  display: inline;
  color: #1867c0;
}
</style>
